import React, { Component } from 'react';
import ProgrammeEvents from '../components/programmeEvents';
import { programmeNotice, programmeEvents } from '../data/programme';

class Programme extends Component {
    render() {
        return (
            <div className="container">
                <h1>Programme 2024/25</h1>
                <p>{programmeNotice}</p>
                <ProgrammeEvents
                    events={programmeEvents}
                />
            </div>
        );
    }
}

export default Programme;


// WEBPACK FOOTER //
// ./src/pages/programme.jsx